import { useHistory } from 'react-router-dom';
import { NavigatorPaths } from '../../assets/dictionaries/NavigatorPaths';

// The Plan screen is tab index 3 of My Settings, and the settings route
// (`settings/:id?`) takes the tab index as its `:id` param.
const PLAN_TAB_INDEX = 3;

// Sends a Basic-plan provider to the Plan tab so they can upgrade. Used by
// every subscription-gated "Create new booking" entry point — the PremiumBadge
// button routes here instead of being a dead, disabled control.
export const useUpgradeToBusinessPlan = () => {
	const history = useHistory();

	return () => {
		history.push(
			`/${NavigatorPaths.settings.path.replace(':id?', PLAN_TAB_INDEX)}`
		);
	};
};
